<template>
  <div ref="echartsContainer" style="width:700px; height: 400px;"></div>
</template>
   
  <script>
import * as echarts from "echarts";

export default {
  name: "EChartsComponent",
  props: {
    data: Array,
  },
  mounted() {
    // console.log(111);
    // console.log(this.data);
    let equity_data = [],
      record_date = [];
    this.data.forEach((item) => {
      equity_data.push(item.total_profit);
      record_date.push(item.record_date);
    });
    var myChart = echarts.init(this.$refs.echartsContainer);
    myChart.setOption({
      tooltip: {
        trigger: "axis",
        axisPointer: {
          type: "shadow"
        }
      },
      grid: {
        left: "3%",
        right: "4%",
        bottom: "3%",
        containLabel: true
      },
      xAxis: [
        {
          type: "category",
          data: record_date,
          // data: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
          axisTick: {
            alignWithLabel: true
          }
        }
      ],
      axisLabel: {
        // 轴文字
        show: false,
        color: "#888891",
        fontSize: 12
      },
      axisLine: {
        // 轴线
        show: true,
        color: "#888891"
      },

      yAxis: [
        {
          type: "value",
          axisTick: {
              // 轴刻度
              show: false,
            },
            axisLine: {
            // 轴线
            show: false
          }
        },
        
      ],
      dataset: {
        source: this.data,
      },
      series: [
        
        {
          name: "Direct",
          type: "bar",
          barWidth: "60%",
          data: equity_data,
          // data: [10, -52, 200, 334, 390, -330, 220],
          itemStyle: {
            // borderRadius: 10, // 统一设置四个角的圆角大小
            borderRadius: [4, 4, 0, 0], //（顺时针左上，右上，右下，左下）
            color: "#FFB951",
            barBorderRadius:[4,4,0,0]
          },
           // 设置高亮（选中）状态下的样式
        emphasis: {
            itemStyle: {
                // 设置选中状态下的背景色
             
            }
        }
        }
      ]
    });
  }
};
</script>
<style scoped>
</style>